import { createContext } from "react";

const AppContext = createContext();
const { Provider } = AppContext;

const AppConfigProvider = ({ children }) => {
  return <Provider value={{}}>{children}</Provider>;
};
export { AppContext, AppConfigProvider };
